import { FC } from 'react';
import { observer } from 'mobx-react';
import { useCheckoutStoreContext } from '~/view/screens/CheckoutScreen/context';
import { localeStore } from '~/mobx/localesStore';
import { ORDER_EDIT_STAGE } from '~/mobx/checkoutStore/constants';
import './style.scss';

const CheckoutCashbackError: FC = observer((): JSX.Element | null => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  if (!checkoutStore.cashbackError || checkoutStore.params.use_wallet || checkoutStore.params.promocode) {
    return null;
  }

  return (
    <>
      {checkoutStore.cashbackUnavailable && checkoutStore.orderEditStage === ORDER_EDIT_STAGE.CHECKOUT && (
        <div className="cashback-error__container">
          <p className="color-red family-regular text-size-16">{localeStore.t('keep_cart_cashback_is_unavailable_notification')}</p>
        </div>
      )}
      {checkoutStore.cashbackChanged &&
        checkoutStore.orderEditStage === ORDER_EDIT_STAGE.CHECKOUT &&
        checkoutStore.dependencies.products.length > 0 && (
          <div className="cashback-unavailable__container">
            <p className="family-regular color-gray2 text-size-16">{localeStore.t('keep_cart_cashback_conditions_changed_popup_bodytext')}</p>
          </div>
        )}
    </>
  );
});

export default CheckoutCashbackError;
